import React, { useEffect, useState } from "react";
import 'common/css/master.css';
import RouteStudents from "./routeStudents";

const UserDrawingsTable = (props) => {
    const { userDrawings, studentsWithCoordinates } = props;

    const [lstUserDrawings, setLstUserDrawings] = useState([]);

    const maxDistance = 1000; // Maximum distance in meters to consider a student inside a drawing
    const [selectedDrawing, setSelectedDrawing] = useState(null); // Track the selected drawing
    const [isDialogOpen, setIsDialogOpen] = useState(false); // Track dialog visibility

    useEffect(() => {
        // console.log("UserDrawingsTable component mounted or updated.");
        // console.log("All Drawings:", userDrawings);
        // console.log("Students with coordinates:", studentsWithCoordinates);
        refreshTable(); // Call refreshTable when the component mounts or updates
    }, [userDrawings, studentsWithCoordinates]); // Dependencies to trigger the effect


    const refreshTable = () => {
        // console.log("Method called: refreshTable");
        // console.log("All Drawings:", userDrawings);
        // console.log("Students with coordinates:", studentsWithCoordinates);

        // Create a copy of userDrawings to update the student count and lstStudents
        const updatedDrawings = userDrawings.map((drawing) => ({
            ...drawing,
            studentCount: 0, // Initialize student count to 0
            lstStudents: [], // Initialize lstStudents as an empty array
        }));

        studentsWithCoordinates.forEach((student) => {
            if (!student.coordinate) return; // Skip if no coordinates

            const studentLatLng = new window.google.maps.LatLng(student.coordinate.lat, student.coordinate.lng);

            let assignedDrawingId = null;
            let minDistance = Infinity;

            // Check if the student is inside any drawing
            updatedDrawings.forEach((drawing) => {
                if (drawing.drawingType === "circle") {
                    const circleCenter = new window.google.maps.LatLng(drawing.center.lat, drawing.center.lng);
                    const distanceToCircle = window.google.maps.geometry.spherical.computeDistanceBetween(studentLatLng, circleCenter);

                    if (distanceToCircle <= drawing.radius) {
                        assignedDrawingId = drawing.drawingId; // Inside the circle
                    } else {
                        const distanceFromCircleEdge = distanceToCircle - drawing.radius;
                        if (distanceFromCircleEdge < minDistance && distanceFromCircleEdge <= maxDistance) {
                            minDistance = distanceFromCircleEdge;
                            assignedDrawingId = drawing.drawingId; // Nearest circle
                        }
                    }
                } else if (drawing.drawingType === "polygon") {
                    const polygonInstance = new window.google.maps.Polygon({ paths: drawing.polygonPath });
                    if (window.google.maps.geometry.poly.containsLocation(studentLatLng, polygonInstance)) {
                        assignedDrawingId = drawing.drawingId; // Inside the polygon
                    } else {
                        // Calculate the perpendicular distance to the nearest edge of the polygon
                        const paths = drawing.polygonPath.map((point) => new window.google.maps.LatLng(point.lat, point.lng));
                        paths.forEach((path, index) => {
                            const nextPath = paths[(index + 1) % paths.length];
                            const distanceToEdge = window.google.maps.geometry.spherical.computeDistanceBetween(
                                studentLatLng,
                                window.google.maps.geometry.spherical.interpolate(path, nextPath, 0.5) // Approximation for perpendicular distance
                            );
                            if (distanceToEdge < minDistance && distanceToEdge <= maxDistance) {
                                minDistance = distanceToEdge;
                                assignedDrawingId = drawing.drawingId; // Nearest polygon
                            }
                        });
                    }
                }
            });

            // Update the student count and lstStudents in the corresponding drawing
            if (assignedDrawingId) {
                const drawingToUpdate = updatedDrawings.find((drawing) => drawing.drawingId === assignedDrawingId);
                if (drawingToUpdate) {
                    drawingToUpdate.studentCount = (drawingToUpdate.studentCount || 0) + 1;
                    drawingToUpdate.lstStudents.push({
                        studentId: student.studentId,
                        name: student.student,
                    });
                }
            }
        });

        setLstUserDrawings(updatedDrawings); // Update the userDrawings state
        // console.log("Updated userDrawings with student counts and lstStudents:", updatedDrawings);
    };

    const saveRouteAreas = () => {
        // console.log("Method called: saveRouteAreas");
        // console.log("All Drawings:", userDrawings);
    }

    const openDialog = (drawing) => {
        setSelectedDrawing(drawing); // Set the selected drawing
        setIsDialogOpen(true); // Open the dialog
    };

    const closeDialog = () => {
        setSelectedDrawing(null); // Clear the selected drawing
        setIsDialogOpen(false); // Close the dialog
    };

    return (
        <div>
            <div className="col-md-12 col-xs-12 col-centered padding-remove">
                <table className="tableLayout1">
                    <colgroup>
                        <col width="33%" />
                        <col width="33%" />
                        <col width="33%" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>Route No</th>
                            <th>Route Name</th>
                            <th>Route Count</th>
                        </tr>
                    </thead>
                </table>
                <div className="tableDiv" style={{ height: "50vh" }}>
                    <table className="tableLayout">
                        <colgroup>
                            <col width="33%" />
                            <col width="33%" />
                            <col width="33%" />
                        </colgroup>
                        <tbody>
                            {lstUserDrawings && lstUserDrawings.length > 0 ? (
                                lstUserDrawings.map((drawing) => (
                                    <tr
                                        key={drawing.drawingId}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => openDialog(drawing)} // Open dialog on row click
                                    >
                                        <td>{drawing.drawingId}</td>
                                        <td>{drawing.drawingName}</td>
                                        <td>{drawing.studentCount || 0}</td> {/* Display student count */}
                                    </tr>
                                ))
                            ) : null}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="col-md-12 col-xs-12 col-centered padding-remove" style={{ marginTop: "10px", display: "flex", justifyContent: "flex-end" }}>
                {/* <button
                    onClick={refreshTable}
                    style={{
                        marginRight: "10px",
                        padding: "10px 20px",
                        backgroundColor: "#6c757d",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                    }}
                >
                    Refresh Table
                </button> */}
                <button
                    onClick={saveRouteAreas}
                    style={{
                        padding: "10px 20px",
                        backgroundColor: "#007bff",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                    }}
                >
                    Save Route Areas
                </button>
            </div>
            {isDialogOpen && selectedDrawing ? (
                <RouteStudents
                    selectedDrawing={selectedDrawing}
                    closeDialog={closeDialog} // Pass closeDialog
                />
            ) : null}
        </div>
    );
};

export default UserDrawingsTable;